module.exports = __webpack_public_path__ + "static/img/nav_pic4.ab7e90f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/nav_pic4.jpg
// module id = lcGo
// module chunks = 37